<div class="slider-container">
  <ng-container *ngFor="let line of getStepLines()">
    <div
      class="step-line step-line-above"
      [class.hidden]="hideLinesAbove"
      [style.left]="getStepLinePosition(line.percentage)"
    ></div>
    <div
      class="step-line step-line-below"
      [class.hidden]="hideLinesBelow"
      [style.left]="getStepLinePosition(line.percentage)"
    ></div>
  </ng-container>
  <div class="slider-track" #track></div>
  <div
    *ngFor="let step of getSteps()"
    class="step-marker"
    [style.left]="getStepPosition(step.percentage)"
    [style.backgroundColor]="step.color"
  ></div>
  <div
    *ngFor="let value of values; let i = index"
    class="slider-thumb"
    [class.default-thumb]="!getThumbImage(i)"
    [class.read-only]="isReadOnly(i)"
    [style.left]="getThumbPosition(i)"
    [style.zIndex]="100 - i"
    (mousedown)="onMouseDown(i, $event)"
  >
    <img
      *ngIf="getThumbImage(i)"
      [src]="getThumbImage(i)"
      alt="Thumb {{ i }}"
      class="thumb-image"
    />
<!--    <span class="slider-value">{{ value }}</span>-->
  </div>
</div>
